import { render, staticRenderFns } from "./UserDetailsValidateNID.vue?vue&type=template&id=66fbe614&"
import script from "./UserDetailsValidateNID.vue?vue&type=script&lang=js&"
export * from "./UserDetailsValidateNID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports